export const nativeEventMaps = new WeakMap();
